import React from "react";
import "./index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { ToastProvider } from "./lib/toast";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import { ForgotPassword, ResetPassword } from "./pages/Password";
import Dashboard from "./pages/Dashboard";
import Companies from "./pages/Companies";
import ContactsList from "./pages/ContactsList";
import CompanyProfile from "./pages/CompanyProfile";
import Quotes from "./pages/Quotes";
import QuoteEdit from "./pages/QuoteEdit";
import Pipeline from "./pages/Pipeline";
import Tasks from "./pages/Tasks";
import Reports from "./pages/Reports";
import SalesActivity from "./pages/reports/SalesActivity";
import PlanSalesTrip from "./pages/reports/PlanSalesTrip";
import Settings from "./pages/Settings";
import AdminUsers from "./pages/admin/Users";
import AdminArchive from "./pages/admin/Archive";
import AdminImport from "./pages/admin/Import";

function Protected({ children, admin=false }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-8">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace/>;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace/>;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route path="/forgot-password" element={<ForgotPassword/>}/>
          <Route path="/reset-password" element={<ResetPassword/>}/>
          <Route path="/" element={<Navigate to="/dashboard" replace/>}/>
          <Route path="/dashboard" element={<Protected><Dashboard/></Protected>}/>
          <Route path="/companies" element={<Protected><Companies/></Protected>}/>
          <Route path="/companies/:id" element={<Protected><CompanyProfile/></Protected>}/>
          <Route path="/contacts" element={<Protected><ContactsList/></Protected>}/>
          <Route path="/quotes" element={<Protected><Quotes/></Protected>}/>
          <Route path="/quotes/new" element={<Protected><QuoteEdit/></Protected>}/>
          <Route path="/quotes/:id" element={<Protected><QuoteEdit/></Protected>}/>
          <Route path="/pipeline" element={<Protected><Pipeline/></Protected>}/>
          <Route path="/tasks" element={<Protected><Tasks/></Protected>}/>
          <Route path="/reports" element={<Protected><Reports/></Protected>}/>
          <Route path="/reports/sales-activity" element={<Protected><SalesActivity/></Protected>}/>
          <Route path="/reports/plan-sales-trip" element={<Protected><PlanSalesTrip/></Protected>}/>
          <Route path="/settings" element={<Protected><Settings/></Protected>}/>
          <Route path="/admin/users" element={<Protected admin><AdminUsers/></Protected>}/>
          <Route path="/admin/archive" element={<Protected admin><AdminArchive/></Protected>}/>
          <Route path="/admin/import" element={<Protected admin><AdminImport/></Protected>}/>
          <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
